import { jsx } from "react/jsx-runtime";
import draggableClassnames from "../../constants/draggableClassnames";
import React from "react";
import Caret from "../Caret";
import { pureNoFunc } from "@teselagen/ui";
import "./style.css";
import getXStartAndWidthOfRangeWrtRow from "../getXStartAndWidthOfRangeWrtRow";
import { getOverlapsOfPotentiallyCircularRanges } from "@teselagen/range-utils";
import {
  getSelectionMessage,
  preventDefaultStopPropagation
} from "../../utils/editorUtils";
function SelectionLayer(props) {
  const {
    charWidth,
    isDraggable,
    row,
    sequenceLength,
    regions,
    leftMargin = 0,
    isProtein,
    showAminoAcidUnitAsCodon,
    getGaps,
    hideTitle: topLevelHideTitle,
    customTitle: topLevelCustomTitle,
    color: topLevelColor,
    hideCarets: topLevelHideCarets = false,
    selectionLayerRightClicked,
    className: globalClassname = "",
    onClick
  } = props;
  let hasSelection = false;
  const toReturn = /* @__PURE__ */ jsx(React.Fragment, { children: regions.map(function(selectionLayer, topIndex) {
    const _onClick = onClick ? function(event) {
      onClick({
        event,
        annotation: selectionLayer
      });
    } : void 0;
    const {
      className = "",
      style = {},
      start,
      end,
      color,
      hideTitle,
      customTitle,
      hideCarets = false,
      ignoreGaps,
      height
    } = selectionLayer;
    const selectionMessage = hideTitle || topLevelHideTitle ? "" : getSelectionMessage({
      selectionLayer,
      customTitle: customTitle || topLevelCustomTitle,
      sequenceLength,
      isProtein,
      showAminoAcidUnitAsCodon
    });
    const onSelectionContextMenu = function(event) {
      selectionLayerRightClicked && selectionLayerRightClicked({
        event,
        annotation: selectionLayer
      });
    };
    const classNameToPass = className + " " + globalClassname;
    if (start > -1) {
      const overlaps = getOverlapsOfPotentiallyCircularRanges(
        selectionLayer,
        row,
        sequenceLength
      );
      if (overlaps.length) hasSelection = true;
      return overlaps.map(function(overlap, index) {
        const key = topIndex + "-" + index;
        let isTrueStart = false;
        let isTrueEnd = false;
        if (overlap.start === selectionLayer.start) {
          isTrueStart = true;
        }
        if (overlap.end === selectionLayer.end) {
          isTrueEnd = true;
        }
        const { xStart, width } = getXStartAndWidthOfRangeWrtRow({
          range: overlap,
          row,
          charWidth,
          sequenceLength,
          ...ignoreGaps ? {} : getGaps(overlap)
        });
        let caretSvgs = [];
        if (!(hideCarets || topLevelHideCarets)) {
          caretSvgs = [
            overlap.start === start && /* @__PURE__ */ jsx(
              Caret,
              {
                ...{
                  isProtein,
                  showAminoAcidUnitAsCodon,
                  leftMargin,
                  onClick: _onClick || preventDefaultStopPropagation,
                  onRightClick: onSelectionContextMenu,
                  charWidth,
                  row,
                  style: selectionLayer.style,
                  getGaps,
                  isDraggable,
                  ignoreGaps,
                  sequenceLength,
                  className: classNameToPass + " selectionLayerCaret " + (isDraggable ? draggableClassnames.selectionStart : ""),
                  caretPosition: overlap.start
                }
              },
              key + "caret1"
            ),
            overlap.end === end && /* @__PURE__ */ jsx(
              Caret,
              {
                ...{
                  isProtein,
                  showAminoAcidUnitAsCodon,
                  leftMargin,
                  onClick: _onClick || preventDefaultStopPropagation,
                  onRightClick: onSelectionContextMenu,
                  charWidth,
                  isDraggable,
                  row,
                  getGaps,
                  style: selectionLayer.style,
                  ignoreGaps,
                  sequenceLength,
                  className: classNameToPass + " selectionLayerCaret " + (isDraggable ? draggableClassnames.selectionEnd : ""),
                  caretPosition: overlap.end + 1
                }
              },
              key + "caret2"
            )
          ];
        }
        const selectionElement = /* @__PURE__ */ jsx(
          "div",
          {
            onClick: _onClick,
            title: selectionMessage,
            onContextMenu: onSelectionContextMenu,
            className: classNameToPass + " veSelectionLayer veRowViewSelectionLayer notCaret " + (isTrueStart ? " isTrueStart " : "") + (isTrueEnd ? " isTrueEnd " : ""),
            style: {
              width,
              left: leftMargin + xStart,
              ...style,
              background: color || topLevelColor,
              height
            }
          },
          key
        );
        let mismatchElements = [];
        if (selectionLayer.mismatchPositions && selectionLayer.mismatchPositions.length > 0) {
          const relativeToOverlap = selectionLayer.mismatchPositions.filter((pos) => {
            const absPos = pos + selectionLayer.start;
            return absPos >= overlap.start && absPos <= overlap.end;
          }).map((pos) => {
            return pos - (overlap.start - selectionLayer.start);
          });
          mismatchElements = relativeToOverlap.map((pos, i) => /* @__PURE__ */ jsx(
            "div",
            {
              className: "veSelectionLayer veMismatchLayer notCaret",
              style: {
                width: charWidth,
                left: leftMargin + xStart + pos * charWidth,
                top: 0,
                height: height || "100%",
                background: "red",
                position: "absolute",
                opacity: 0.5
              }
            },
            `${key}-mismatch-${i}`
          ));
        }
        return [selectionElement, ...mismatchElements, ...caretSvgs];
      });
    } else {
      return null;
    }
  }) });
  return hasSelection ? toReturn : null;
}
export default pureNoFunc(SelectionLayer);
